<div class="col-md-12 mb-30" [hidden]="Selected_DeviceBehfa_Record.id>0 || FormTypeShow!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Reference Certificate Request List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Behfa Code</label>
          <input [(ngModel)]="Filter_BehfaCode" name="Filter_BehfaCode" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Status </label>
          <select [(ngModel)]="Filter_Status" name="Filter_Status" class="custom-select">
            <option value="0">All</option>
            <option value="1">Under Review</option>
            <option value="2">Rejected</option>
            <option value="3">Approved</option>

          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceBehfa(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Request ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Certificate No.</th>
              <th>Cal. Due</th>

              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_DeviceBehfa
                  |filter:Filter_title:'fullname'
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 50,
                              currentPage: page,
                              totalItems: (DataList_DeviceBehfa|filter:Filter_title:'fullname').length
                            }">

              <tr>
                <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
                <td>{{item.id}}</td>

                <td>{{item.description}}</td>
                <td>{{item.manufacturer}}</td>
                <td>{{item.codeBEHFA}}</td>
                <td>{{item.model}}</td>
                <td>{{item.certificateNo}}</td>
                <td>{{item.calDue}}</td>
                

                <td>
                  <p *ngIf="item.status==1" style="color: rgb(20, 77, 220);">Under Review</p>
                  <p *ngIf="item.status==2" style="color: #489b39;">Approve</p>
                  <p *ngIf="item.status==3" style="color: crimson;">Reject</p>
                </td>

                <td rowspan="3">
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="ReadData_Form(item)" class="dropdown-item"><i class="fa fa-eye"></i> View
                        </a>
                        <a *ngIf="item.status==2" style="cursor: pointer;" (click)="ReadData_View(item)" class="dropdown-item"><i class="fa fa-leanpub"></i> Revision
                        </a>
                        <a href="{{BaseUrl1}}{{item.flowchart.flochart_id}}{{BaseUrlCo}}{{item.flowchart.makerId}}"  target="_blank" class="dropdown-item"><i
                            class="fa fa-wpbeginner"></i>
                          Workflow
                        </a>
                        <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i class="fa fa-history"></i>
                        Workflow History
                        </a>




                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>Full Name</th>
                <td colspan="2">{{item.fullname}}</td>
                <th>Registration Date</th>
                <td colspan="2">{{item.persianDate}}</td>
                <th>Workflow</th>
                <td colspan="2">{{item.flowchart.flochart_title}}</td>
              </tr>
              <tr>
                <th colspan="2">Description</th>
                <td colspan="7">{{item.dsc}}</td>
              </tr>



            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_DeviceBehfa_Record.id>0 && FormTypeShow=='View'">
  <app-DeviceBehfaReviewForm
    [inner_request_id]="Selected_DeviceBehfa_Record.id">
    
  </app-DeviceBehfaReviewForm>

  <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
  </button>
</div>

<div *ngIf="Selected_DeviceBehfa_Record.id>0 && FormTypeShow=='History'" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Request Workflow History '{{Selected_DeviceBehfa_Record.flowchart.uniCode}}' </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button" (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>Delete Last Referral</button>
        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
  </div>
  
</div>
